import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'costOverviewSection.title',
    defaultMessage: 'Cost overview',
    description: 'Title of the cost overview section',
  },
  options: {
    currentPrices: {
      id: 'costOverviewSection.options.currentPrices',
      defaultMessage: 'Current prices',
      description: 'Label of the current prices option in the cost overview section',
    },
  },
  overview: {
    post: {
      id: 'costOverviewSection.overview.post',
      defaultMessage: 'Post',
      description: 'Title of the post column of the cost overview',
    },
    amount: {
      id: 'costOverviewSection.overview.amount',
      defaultMessage: 'Amount',
      description: 'Title of the amount column of the cost overview',
    },
    vat: {
      id: 'costOverviewSection.overview.vat',
      defaultMessage: 'VAT',
      description: 'Title of the vat rows of the cost overview',
    },
    ofWhichVat: {
      id: 'costOverviewSection.overview.ofWhichVat',
      defaultMessage: 'Of which VAT',
      description: 'Title of the of which vat rows of the cost overview',
    },
    shiftedVat: {
      id: 'costOverviewSection.overview.shiftedVat',
      defaultMessage: 'shifted',
      description: 'Title of the of which vat rows of the cost overview',
    },
    subtotal: {
      id: 'costOverviewSection.overview.subtotal',
      defaultMessage: 'Subtotal',
      description: 'Title of the subtotal row of the cost overview',
    },
    total: {
      id: 'costOverviewSection.overview.total',
      defaultMessage: 'Total',
      description: 'Title of the total row of the cost overview',
    },
  },
};

export default defineMessages(translations);
